<template>
  <div class="provider-popup-wrapper">
    <router-link class="provider-name" :to="{ id: 'detail',
        params: { providerId: location.provider.providerId } }">
      {{ location.name }}
    </router-link>
    <div class="provider-description" v-html="locationDescription"></div>
    <div class="provider-address" v-html="locationAddress"></div>
    <a v-if="location.discountLink" :href="provider.discountLink" target="_blank"
        class="online-button primary-button">
      {{ $t("discount.buttons.getDiscountOnline") }}
    </a>
  </div>
</template>

<style scoped>
  .provider-popup-wrapper {
    color: #738583;
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
  }

  .provider-name {
    color: var(--primary-color);
    font-weight: 700;
    margin-bottom: 16px;
    text-decoration: none;
    font-size: 14px;
  }

  .provider-description {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .online-button {
    margin: 16px 0 8px 0;
    color: white;
  }

</style>

<script>
import { mapState } from 'vuex';
import RouterLink from '@/router/RouterLink.vue';

export default {
  name: 'provider-popup',
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  components: {
    RouterLink,
  },
  computed: {
    ...mapState({
      locale: (state) => state.config.locale,
    }),
    locationAddress() {
      let address = this.location.address1;
      address += this.location.address2 ? `, ${this.location.address2}` : '';
      address += '</br>';
      address += this.location.postalCode ? `${this.location.postalCode} ` : '';
      address += this.location.city.name;
      return address;
    },
    locationDescription() {
      let description = '';
      // Hack that allows to change attribute name on BE in the future.
      const locationBenefits = this.location.benefit ? this.location.benefit
        : this.location.benefits;
      locationBenefits.forEach((benefit) => {
        if (benefit.benefitL10ns != null) {
          const L10n = benefit.benefitL10ns.find((item) => item.languageCode === this.locale);
          if (L10n != null) {
            description += `${L10n.summary} </br>`;
            return;
          }
        }
        description += `${benefit.benefitSummary} </br>`;
      });
      return description;
    },
  },
};
</script>
